import {productContentBlockSettings, ProductContentBlockSettings} from '../../../bps/components/productContentBlock/productContentBlockSettings';

productContentBlockSettings.readMoreHeight = 150;

export {productContentBlockSettings, ProductContentBlockSettings}
